module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.6786546.ttf";